/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_Pain_OtherInputs */

const en_us2_workout_after_pain_other = /** @type {(inputs: Workout_After_Pain_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something else`)
};

const pt_br2_workout_after_pain_other = /** @type {(inputs: Workout_After_Pain_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outra coisa`)
};

const es_419_workout_after_pain_other = /** @type {(inputs: Workout_After_Pain_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otra cosa`)
};

const pt_pt2_workout_after_pain_other = /** @type {(inputs: Workout_After_Pain_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outra coisa`)
};

const fr_fr2_workout_after_pain_other = /** @type {(inputs: Workout_After_Pain_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autre chose`)
};

const de_de2_workout_after_pain_other = /** @type {(inputs: Workout_After_Pain_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etwas anderes`)
};

const it_it2_workout_after_pain_other = /** @type {(inputs: Workout_After_Pain_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altro`)
};

/**
* | output |
* | --- |
* | "Something else" |
*
* @param {Workout_After_Pain_OtherInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_pain_other = /** @type {((inputs?: Workout_After_Pain_OtherInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Pain_OtherInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_pain_other(inputs)
	if (locale === "es-419") return es_419_workout_after_pain_other(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_pain_other(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_pain_other(inputs)
	if (locale === "de-DE") return de_de2_workout_after_pain_other(inputs)
	if (locale === "it-IT") return it_it2_workout_after_pain_other(inputs)
	return en_us2_workout_after_pain_other(inputs)
});
export { workout_after_pain_other as "workout-after.pain_other" }